<template>
    <ul v-if="navitems" class="child">
        <router-link
            :to="getRoute(item.route)"
            v-for="(item, itemindex) in navitems"
            :key="itemindex"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
        >
            <li
                :class="[
                    isActive && 'active',
                    isExactActive && 'exact-active',
                    item.children && 'has-children'
                ]"
                v-show="isCurrentPath(href, isActive)"
            >
                <a :href="href" @click="navigate">{{ item.name }}</a>
                <nav-tree
                    :items="item.children"
                    :parent="getRoute(item.route)"
                ></nav-tree>
            </li>
        </router-link>
    </ul>
</template>

<script>
import collect from 'collect.js';
import { mapState } from 'vuex';
export default {
    name: 'nav-tree',
    props: ['items', 'parent'],
    computed: {
        ...mapState('products', ['products']),
        navitems() {
            let products = collect(this.products);
            return collect(this.items)
                .map(item => {
                    if (item.products) {
                        item.children = collect(item.products)
                            .map(product => {
                                const found = products
                                    .where('id', product)
                                    .first();
                                return {
                                    name: found.name,
                                    route: found.id
                                };
                            })
                            .all();
                    }
                    return item;
                })
                .all();
        }
    },
    methods: {
        getRoute(route) {
            return `${this.parent}/${route}`;
        },

        isCurrentPath(href, isActive) {
            if (
                this.parent === '/application' &&
                this.$route.matched.length > 2
            ) {
                return isActive;
            }

            return true;
        }
    }
};
</script>

<style>
</style>
